<main class="main">
  <div class="card mt-4 bg-neutral text-neutral-content inset-x-0 max-w-max mx-auto font-montserrat">

    <!-- Setup 2FA Section -->
    @if (settingUp && qrCodeUrl && manualEntryCode) {
      <div class="card-body mx-8 flex items-center justify-center flex-col">
        <h2 class="font-light text-xl md:text-2xl termina-regular">Set Up 2FA</h2>
        <app-logo class="w-[100px] my-4"></app-logo>
        <div class="text-lg">
          To initialise two factor authentication, scan the below QR code using your authenticator app
        </div>
        @if (qrCodeUrl) {
          <img class="w-52 mb-8" [src]="qrCodeUrl" alt="">
        }
        <div class="text-lg mb-4">
          Or, enter the following key into your authenticator app manually:
        </div>
        @if (manualEntryCode) {
          <div class="font-bold mb-12 break-all">{{ manualEntryCode }}</div>
        }
      </div>
    }

    <!-- Enable 2FA (Enter Code) Section -->
    @if (!settingUp) {
      <div class="card-body mx-8 flex items-center justify-center flex-col">
        <h2 class="font-light text-xl md:text-2xl termina-regular">Set Up 2FA</h2>
        <app-logo class="w-[100px] my-4" ></app-logo>
        <div class="text-lg mb-8">
          To enable two factor authentication, please enter the code from your authenticator app
        </div>
        <form (submit)="enableTwoFactor()" [formGroup]="enableTwoFactorForm" class="flex flex-col items-center">
          <label for="twoFactorCode">Two Factor Code</label>
          <input id="twoFactorCode" class="input mt-2" formControlName="twoFactorCode" required name="text" type="text"/>
        </form>
      </div>
    }
  </div>

  <div class="flex justify-center">
    @if (settingUp && qrCodeUrl && manualEntryCode) {
      <button class="mt-2 btn btn-neutral" matRipple type="button" (click)="finishSetup()">
        Done
      </button>
    }
    @if (!settingUp) {
      <button [disabled]="!enableTwoFactorForm.valid" class="mt-2 btn btn-neutral" matRipple type="submit" (click)="enableTwoFactor()">
        Enable
      </button>
    }
  </div>
</main>